import { DyProductSource } from 'src/interfaces';

export const shouldDisplayProductsOptions = (
  productsSource?: DyProductSource,
) => productsSource !== DyProductSource.DYS;
